export const AuthenticationType = {
  SFA: 'SFA',
  MFA: 'MFA',
};
